// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2504":"8afc6be8","3035":"b7b91cb1","3837":"8afc6be8","5572":"8afc6be8","6154":"360bec10","7784":"b7b91cb1","7823":"204b33e9","8339":"360bec10","8688":"27dd0431","8871":"b7b91cb1","9591":"360bec10"}[chunkId] + ".chunk.css";
};